import { render, staticRenderFns } from "./KTDW.vue?vue&type=template&id=2f4b1fcc&scoped=true"
import script from "./KTDW.vue?vue&type=script&lang=js"
export * from "./KTDW.vue?vue&type=script&lang=js"
import style0 from "./KTDW.vue?vue&type=style&index=0&id=2f4b1fcc&prod&lang=css"
import style1 from "./KTDW.vue?vue&type=style&index=1&id=2f4b1fcc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4b1fcc",
  null
  
)

export default component.exports